module.exports = __webpack_public_path__ + "static/img/step2.c39ae3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step2.png
// module id = FLts
// module chunks = 128